export default "__VITE_ASSET__DkwXlH7o__"